import client from '../graphql/client';

export function useClient() {
    return client;
}
